var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(['PageNotFound', 'ResetPass', 'Redirector'].indexOf(_vm.$route.name) == -1)?_c('Navbar'):_vm._e(),_c('v-main',{staticClass:"header"},[_c('router-view')],1),(_vm.$route.path === '/')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }